/**
 * README "Remove website dialog — 400px". No typed-name confirmation —
 * removing an allowlist entry is reversible (the domain can be re-added),
 * unlike deleting a calendar, so this dialog is lighter than
 * component/WidgetIndex/DeleteModal.jsx.
 */
import React from "react";
import ConfirmDialog from "../../theme/untitled/ConfirmDialog/ConfirmDialog";
import Icon from "../../theme/untitled/icons/Icon";

const RemoveWebsiteDialog = ({ domain, busy, errorMessage, onClose, onConfirm }) => (
  <ConfirmDialog
    open={!!domain}
    onClose={onClose}
    onConfirm={onConfirm}
    icon={<Icon name="Trash01" size={24} />}
    title={domain ? `Remove ${domain.domain}?` : ""}
    confirmLabel={busy ? "Removing…" : errorMessage ? "Try again" : "Remove website"}
    busy={busy}
  >
    <p>
      Widgets stop loading on this domain immediately. Any live page embedding one will show
      nothing until the domain is added again.
    </p>
    <p>Your calendars and widgets are not affected, and you can add the domain back at any time.</p>
    {errorMessage && (
      <p>
        <Icon name="AlertTriangle" size={16} /> Nothing was removed &mdash; the domain is still
        allowed. {errorMessage}
      </p>
    )}
  </ConfirmDialog>
);

export default RemoveWebsiteDialog;
